import { useState } from 'react'
import TableTab3 from "./TableTab3";
import {
  useItemTaxTemplateMutation,
  useItemTaxCategoryMutation,
} from "../../../../store/api/itemapi";
const Tab3 = ({ pageState,setPageState,setselected_tax_item_data,list_itemtax_data,list_item_tax_category_data}) => {
  const [ItemTaxTemplateApi] = useItemTaxTemplateMutation();
  const [ItemTaxCategoryApi] = useItemTaxCategoryMutation();
  return (
     <div>
      <div className="px-4" style={{ background: 'white' }}>
   <div className="mb-3" style={{ display: 'flex', gap: '20px',border: '1px solid #DBDBDB', borderRadius: '5px' }} >

            <div className="col-md-12">
              <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
 <div style={{ display: 'flex', gap: '15px'}}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Item Tax</p>
                </div>
              </div>

                  <TableTab3  setselected_tax_item_data={{
    value: pageState.selected_tax_item_data || [],
    setValue: (val) =>
      setPageState({
        ...pageState,
        selected_tax_item_data: val,
      }),
  }} list_itemtax_data={ItemTaxTemplateApi} list_item_tax_category_data={ItemTaxCategoryApi}/>



              </div>
            </div>

          </div>
          </div>
          </div>
  )
}

export default Tab3